// test2912
(2912 && 0);
